export default {
  CompanyInfo: 'Thông tin đơn vị',
  QHNS: 'Mã QHNS',
  QHNS_Tooltip: 'Mã quan hệ ngân sách',
  NameCompany: 'Tên đơn vị',
  AcronymNameCompany: 'Tên đơn vị viết tắt',
  Provine: 'Tỉnh/TP',
  District: 'Quận/Huyện',
  Commune: 'Xã/Phường',
  TaxCode: 'Mã số thuế',
  AddressCode: 'Mã địa bàn',
  Phone: 'Điện thoại',
  Fax: 'Fax',
  EtreasuryInfo: 'Thông tin kho bạc',
  Code: 'Mã số',
  PlaceOpen: 'Nơi mở',
  ProvinceTitle: 'Tỉnh/Thành phố',
  ProvineTitle: 'Tỉnh/Thành phố',
  InvestorInfo: 'Thông tin Chủ đầu tư',
  InvestorBudgetRelationCode: 'Mã QHNS Chủ đầu tư',
  InvestorName: 'Tên Chủ đầu tư',
};
